import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const location = useLocation();
  const settings = useSettings();
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/managers`).then(r => setManagers(r.data)).catch(() => {});
  }, []);

  if (location.pathname.startsWith("/admin") || location.pathname === "/login") return null;

  const footerDesc = settings?.footer_description || "Профессиональный подбор, пригон и таможенное оформление автомобилей из Европы.";
  const footerCopy = settings?.footer_copyright || "AutoPride Group. Все права защищены.";
  const tgChannel = settings?.telegram_channel || "";

  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-[#050505] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `linear-gradient(rgba(212,175,55,1) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,1) 1px, transparent 1px)`,
        backgroundSize: "80px 80px"
      }} />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/favicon.png" alt={settings?.logo_text || "AutoPride"} className="w-10 h-10" />
              <span data-testid="footer-logo-text" className="font-semibold text-lg text-[#D4AF37]" style={{ fontFamily: "'Playfair Display', serif" }}>
                {settings?.logo_text || "AUTOPRIDE"}
              </span>
            </div>
            <p data-testid="footer-description" className="text-[#A3A3A3] text-sm leading-relaxed">
              {footerDesc}
            </p>
            {tgChannel && (
              <a href={tgChannel} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-4 px-4 py-2 border border-[#0088cc]/40 bg-[#0088cc]/10 text-[#58b6e8] hover:bg-[#0088cc] hover:text-white hover:border-[#0088cc] transition-all duration-300 text-xs uppercase tracking-widest font-medium" data-testid="footer-telegram-channel">
                <Send className="w-3.5 h-3.5" />
                Наш Telegram-канал
              </a>
            )}
          </div>

          <div>
            <h4 className="text-sm font-medium tracking-widest uppercase text-[#D4AF37] mb-4">Навигация</h4>
            <div className="space-y-2">
              {[
                { to: "/", label: "Главная" },
                { to: "/podbor", label: "Подбор" },
                { to: "/services", label: "Услуги" },
                { to: "/catalog", label: "Каталог" },
                { to: "/reviews", label: "Отзывы" },
                { to: "/contacts", label: "Контакты" },
              ].map((link) => (
                <Link key={link.to} to={link.to} className="block text-sm text-[#A3A3A3] hover:text-white transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium tracking-widest uppercase text-[#D4AF37] mb-4">Контакты</h4>
            <div className="space-y-2 text-sm text-[#A3A3A3]">
              {settings?.contacts_phone && (
                <p className="hover:text-white transition-colors">{settings.contacts_phone}</p>
              )}
              {settings?.contacts_email && (
                <a href={`mailto:${settings.contacts_email}`} className="block hover:text-[#D4AF37] transition-colors">{settings.contacts_email}</a>
              )}
              {settings?.contacts_address && (
                <p>{settings.contacts_address}</p>
              )}
              {managers.map(m => (
                m.telegram && (
                  <a key={m.id} href={m.telegram} target="_blank" rel="noopener noreferrer" className="block hover:text-[#D4AF37] transition-colors">
                    {m.name} — Telegram
                  </a>
                )
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 text-center">
          <p data-testid="footer-copyright" className="text-xs text-[#A3A3A3]">
            &copy; {new Date().getFullYear()} {footerCopy}
          </p>
        </div>
      </div>
    </footer>
  );
}
